module.exports = __webpack_public_path__ + "static/img/chewr.2f633a7a.webp";